import { RFQStatus } from '../types';

export const getStatusLabel = (status: RFQStatus): string => {
    switch (status) {
        case RFQStatus.WAITING_FOR_DOCUMENTS:
            return 'Waiting for Documents';
        case RFQStatus.WAITING_FOR_CLIENT_FEEDBACK:
            return 'Waiting for Client Feedback';
        case RFQStatus.COMPLETED:
            return 'Completed';
        default:
            return status;
    }
};

export const getStatusColor = (status: RFQStatus): string => {
    switch (status) {
        case RFQStatus.WAITING_FOR_DOCUMENTS:
            return 'bg-[#b87a1a]/10 text-[#8a5a2b] border border-[#b87a1a]/40';
        case RFQStatus.WAITING_FOR_CLIENT_FEEDBACK:
            return 'bg-[#1e5f8f]/10 text-[#1e5f8f] border border-[#1e5f8f]/40';
        case RFQStatus.COMPLETED:
            return 'bg-[#4a6b3d]/10 text-[#4a6b3d] border border-[#4a6b3d]/40';
        default:
            return 'bg-[#141414]/5 text-[#141414]/70 border border-[#141414]/20';
    }
};
